import { apiUrlOriginacao, enableApiMocks, featureFlags } from "@settings";

export const enableMocking = async () => {
  if (!enableApiMocks && !featureFlags.enablePagoalLoginMock) return;

  const { worker } = await import("./browser");
  return worker.start({
    onUnhandledRequest(req, print) {
      if (!req.url.includes(apiUrlOriginacao)) return;
      print.warning();
    },
  });
};
